module.exports = __webpack_public_path__ + "static/media/Both.07f329bf.svg";